export default __webpack_public_path__ + "static/media/nft.55ee92bd.gif";